import { createGlobalStyle } from 'styled-components/macro';

const GlobalStyle = createGlobalStyle`
  #certiself-form {
    font-family: 'Helvetica Neue', Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizelegibility;
    position: relative;
    z-index: 1; 
  }

  #certiself-form > *,
  #certiself-form p,
  #certiself-form h1,
  #certiself-form h2 {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  #certiself-form h1,
  #certiself-form h2 {
    font-family: 'proxima-nova', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  #certiself-form > *::-webkit-scrollbar {
    height: 5px;
    width: 6px;
  }

  #certiself-form > *::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.28);
  }

  #certiself-form > *::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.1);
  }
`;

export default GlobalStyle;
